import PropTypes from 'prop-types';
import { Button } from '@andes/button';
import { ActionModal } from '@vpp-frontend-components/action-modal';
import { onIframeModalResize } from '@vpp-frontend-components/common';
import { Iframe } from '@vpp-frontend-components/iframe';

const MessageJsonAction = props => {
  const { buttonClassName, text, url, target = '_blank', modalProps = {}, hierarchy = 'loud' } = props;
  const { title: modalTitle, close_label: modalCloseLabel, url: modalUrl } = modalProps;

  if (!modalTitle) {
    return (
      <Button
        data-testid="action-button"
        className={buttonClassName}
        hierarchy={hierarchy}
        href={url}
        size="medium"
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {text}
      </Button>
    );
  }

  return (
    <ActionModal
      className="returns-notification__action-modal"
      modalClassName="ui-pdp-iframe-modal ui-pdp-apparel-size-modal"
      componentAsLabel={
        <Button className={buttonClassName} hierarchy={hierarchy} size="medium">
          {text}
        </Button>
      }
      url={url}
      modalUrl={modalUrl}
      modalTitle={modalTitle}
      closeModalLabel={modalCloseLabel}
    >
      <Iframe
        scrolling="auto"
        src={url}
        title={text}
        onMessage={onIframeModalResize(
          'vip:modal-content:loaded',
          'height',
          '.ui-pdp-iframe-modal',
          '.andes-modal__header',
        )}
      />
    </ActionModal>
  );
};

MessageJsonAction.propTypes = {
  buttonClassName: PropTypes.string,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  target: PropTypes.oneOf(['_blank', '_self']),
  hierarchy: PropTypes.oneOf(['loud', 'transparent']),
  modalProps: PropTypes.shape({
    title: PropTypes.string,
    closeLabel: PropTypes.string,
    url: PropTypes.string,
  }),
};

export default MessageJsonAction;
